import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import Axios from "axios";
import M from "materialize-css";
import { StateContext } from "../App";
import "./signup.css";

function Signup(props) {
  const { dispatch } = useContext(StateContext);
  // console.log("SIgn up component", props);

  const [planError, setPlanError] = useState("");
  const [plan, setPlan] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const signUp_form = async (e) => {
    e.preventDefault();
    document.querySelector(".not-loading-btn").style.display = "none";
    document.querySelector(".btn-back").style.display = "block";

    setName("");
    setEmail("");
    setUsername("");
    setPassword("");

    const form = document.querySelector(".signup-form");


    const name = form.fullname.value;
    const username = form.username.value;
    const email = form.email.value;
    const password = form.password.value;
    const passwordConfirm = form.confirm_password.value;



    const link = window.location.hash;
    console.log(link);
    const split = link.split("/");
    // console.log(split[2])
    const referral_id = split[2];


    // check for a referral Id Here!
    if (referral_id !== undefined ) { 
      // console.log("yes Id")
      if (password === passwordConfirm) {
        try {
          const result = await Axios.post(`/signup/${referral_id}`, {
            name,
            username,
            email,
            password,
          });
          /* result && console.log("the axios request result", result.data.customer);
          result &&
            console.log("the axios Error request result", result.data.error); */
  
          // show various error / Update the UI HERE with errors!
          if (result.data.error) {
            document.querySelector(".not-loading-btn").style.display = "block";
            document.querySelector(".btn-back").style.display = "none";
            setName(result.data.error.name);
            setEmail(result.data.error.email);
            setUsername(result.data.error.username);
            setPassword(result.data.error.password);
          }
  
          // check for user and set to the state with auth!
          if (result.data.customer !== undefined) {
            document.querySelector(".not-loading-btn").style.display = "block";
            document.querySelector(".btn-back").style.display = "none";
            dispatch({ type: "SET_AUTH", payload: true });
            localStorage.setItem("user", JSON.stringify(result.data.customer._id));
            props.history.push("/dashboard/overview");
          }
          result.data.error && dispatch({ type: "SET_AUTH", payload: false });
        } catch (err) {
          console.log(err);
        }
      } else {
        document.querySelector(".not-loading-btn").style.display = "block";
        document.querySelector(".btn-back").style.display = "none";
        password !== passwordConfirm &&
          setPassword("your password does not match!");
        // console.log('password does not match')
      }
    }
    else {
      // console.log("no Id")
      if (password === passwordConfirm) {
        try {
          const result = await Axios.post("/signup", {
            name,
            username,
            email,
            password,
          });
          /* result && console.log("the axios request result", result.data.customer);
          result &&
            console.log("the axios Error request result", result.data.error); */
  
            console.log('Data! ==', result)
            console.log('Data Err! ==', result.data)
          // show various error / Update the UI HERE with errors!
          if (result.data.error) {
            document.querySelector(".not-loading-btn").style.display = "block";
            document.querySelector(".btn-back").style.display = "none";
            setName(result.data.error.name);
            setEmail(result.data.error.email);
            setUsername(result.data.error.username);
            setPassword(result.data.error.password);
          }
  
          // check for user and set to the state with auth!
          if (result.data.customer !== undefined) {
            document.querySelector(".not-loading-btn").style.display = "block";
            document.querySelector(".btn-back").style.display = "none";
            dispatch({ type: "SET_AUTH", payload: true });
            localStorage.setItem("user", JSON.stringify(result.data.customer._id))
            props.history.push("/dashboard/overview");
          }
          result.data.error && dispatch({ type: "SET_AUTH", payload: false });
        } catch (err) {
          console.log(err);
        }
      } else {
        document.querySelector(".not-loading-btn").style.display = "block";
        document.querySelector(".btn-back").style.display = "none";
        password !== passwordConfirm &&
          setPassword("your password does not match!");
        // console.log('password does not match')
      }
    }
    
  };

  const handleBasic = (e) => {
    // alert()
    e.persist();
    // console.log(e.target.checked)
    if (e.target.checked) {
      setPlan("basic");
    } else {
      setPlan("");
    }
  };

  const handleRegular = (e) => {
    e.persist();
    if (e.target.checked) {
      setPlan("regular");
    } else {
      setPlan("");
    }
  };

  const handlePremium = (e) => {
    e.persist();
    if (e.target.checked) {
      setPlan("premium");
    } else {
      setPlan("");
    }
  };

/* 
  CheckBox validation!...
  const checkBox = document.querySelectorAll(".signup-checkbox");
  let i;
  for (i = 0; i < checkBox.length; i++) {
    checkBox[i].addEventListener("change", (e) => {
      if (checkBox[0].checked && checkBox[1].checked) {
        setPlanError("pick only one");
      } else if (checkBox[1].checked && checkBox[2].checked) {
        setPlanError("pick only one");
      } else if (checkBox[0].checked && checkBox[2].checked) {
        setPlanError("pick only one");
      } else {
        setPlanError("");
      }
    });
  }
 */
  
  return (
    <div className="signup">
      <div className="centered">
        <form className="signup-form" onSubmit={signUp_form}>
          <h3>signup</h3>
          <span className="error">{planError}</span>
          {/* FullName */}
          <div className="input-field">
            <input
              type="text"
              name="fullname"
              placeholder="enter full name"
              className="fullname_input"
            />
            <span className="error">{name}</span>
          </div>
          {/* username */}
          <div className="input-field">
            <input
              type="text"
              name="username"
              placeholder="enter a username"
              className="username_input"
            />
            <span className="error">{username}</span>
          </div>
          {/* email */}
          <div className="input-field">
            <input
              type="email"
              name="email"
              placeholder="enter your email"
              className="email_input"
            />
            <span className="error">{email}</span>
          </div>
          {/* Password */}
          <div className="input-field">
            <input
              required
              type="password"
              name="password"
              placeholder="enter your password"
              className="password_input"
            />
          </div>
          {/* Confirm-Password */}
          <div className="input-field">
            <input
              type="password"
              name="confirm_password"
              placeholder="confirm password"
              className="confirm_password_input"
            />
            <span className="error">{password}</span>
          </div>
          <div className="input-field">
            <button className="not-loading-btn">signup</button>
            <div className="btn-back">
              <button disabled className="loading-btn">
                <div id="loader"></div>
              </button>
            </div>
          </div>
          <div className="action-btn">
            <span>already have an account!</span>
            <Link to="/login">login</Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Signup;
